export var TimeOptions;
(function (TimeOptions) {
    TimeOptions["MAXIMUM_STRING"] = "9223372036854775807";
    TimeOptions["MINIMUM_STRING"] = "-9223372036854775807";
})(TimeOptions || (TimeOptions = {}));
export function timeToMilliseconds(time) {
    return time.toString().slice(0, -3);
}
//# sourceMappingURL=Time.js.map